/**
 * Toggle MaterialTable row selection when the row body is clicked.
 * Skips clicks on checkboxes, buttons, links, and icon actions.
 */
export function toggleTableRowSelection(event, rowData, tableRef, setSelectedRows) {
  const interactive = event?.target?.closest?.(
    "button, a, input, label, .MuiIconButton-root, .MuiCheckbox-root, .MuiButtonBase-root"
  );
  if (interactive) return;
  if (!rowData || !tableRef?.current?.dataManager) return;

  const table = tableRef.current;
  const rowId = rowData.tableData?.id;
  if (rowId === undefined || rowId === null) return;

  const path =
    Array.isArray(rowData.tableData?.path) && rowData.tableData.path.length
      ? rowData.tableData.path
      : [rowId];

  const currentlyChecked = !!rowData.tableData?.checked;
  table.dataManager.changeRowSelected(!currentlyChecked, path);
  table.setState(table.dataManager.getRenderState(), () => {
    const selected = (table.dataManager.data || []).filter(
      (row) => row?.tableData?.checked
    );
    setSelectedRows(selected);
  });
}
